import http from "../axios/http-common";

class InterfaceSoap {
  getSoapDokter(reg, idUser) {
    // return http.get(`/poli/${kdPoli}/daftar-pasien?tgl=${tgl}&status=${status}&dr=${kdDokter}`);
    return http.getDataParam(`/register/${reg}/soap-dokter`, {
      params: {
        user_id: idUser
      }
    });
  }

  getAllSoapDokter(reg) {
    // return http.get(`/poli/${kdPoli}/daftar-pasien?tgl=${tgl}&status=${status}&dr=${kdDokter}`);
    return http.getData(`/register/${reg}/soap-dokter`);
  }

  getSoapPerawat(reg, idUser) {
    // return http.get(`/poli/${kdPoli}/daftar-pasien?tgl=${tgl}&status=${status}&dr=${kdDokter}`);
    return http.getDataParam(`/register/${reg}/soap-perawat`, {
      params: {
        user_id: idUser
      }
    });
  }
  getAllSoapPerawat(reg) {
    // return http.get(`/poli/${kdPoli}/daftar-pasien?tgl=${tgl}&status=${status}&dr=${kdDokter}`);
    return http.getData(`/register/${reg}/soap-perawat`);
  }

  saveSoapDokter(reg, cm, userId, idUnit, s, o, a, p, ins, time = null) {
    return http.postData(`/soap-dokter`, {
      register_id: reg,
      pasien_cm: cm,
      dr_id: userId,
      unit_id: idUnit,
      subjective: s,
      objective: o,
      assesment: a,
      plan: p,
      instruksi: ins,
      examined_at: time
    });
  }

  saveSoapPerawat(reg, cm, userId, idUnit, s, o, a, p, ins, time) {
    return http.postData(`/soap-perawat`, {
      register_id: reg,
      pasien_cm: cm,
      user_id: userId,
      unit_id: idUnit,
      subjective: s,
      objective: o,
      assesment: a,
      plan: p,
      instruksi: ins,
      examined_at: time
    });
  }

  changeSoapDokter(s, o, a, p, ins, time = null, idSoap) {
    return http.putData(`/soap-dokter/${idSoap}`, {
      subjective: s,
      objective: o,
      assesment: a,
      plan: p,
      instruksi: ins,
      examined_at: time
    });
  }

  changeSoapPerawat(s, o, a, p, ins, time = null, idSoap) {
    return http.putData(`/soap-perawat/${idSoap}`, {
      subjective: s,
      objective: o,
      assesment: a,
      plan: p,
      instruksi: ins,
      examined_at: time
    });
  }

  getAllSoap(reg) {
    return http.getData(`/register/${reg}/soap`);
  }

  deleteSoapPerawat(idSoap, alasan) {
    return http.deleteDataParam(`/soap-perawat/${idSoap}`, {
      params: {
        alasan: alasan
      }
    });
  }
  deleteSoapDokter(idSoap, alasan) {
    return http.deleteDataParam(`/soap-dokter/${idSoap}`, {
      params: {
        alasan: alasan
      }
    });
  }
}

export default new InterfaceSoap();
